import { Box,Divider } from '@material-ui/core'
import './amsdivider.css'

const AmsDivider = (props: any) => {
   
    return (
        <Box className='divider'>
            <Divider />
        </Box>
    )
}

export default AmsDivider